import React from 'react';
import { BookOpen, Award, Heart, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 to-white">
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-start mb-16">
            <div className="aspect-square bg-pink-50 rounded-2xl shadow-2xl flex items-center justify-center" data-aos="zoom-in">
              <div className="text-center space-y-4 p-4">
                <div className="w-128 h-128 mx-auto bg-white rounded-lg flex items-center justify-center">
                 <img 
                  src="./personal.jpeg" 
                  alt="Arlene" 
                  className="w-full h-full object-cover"
                />
              </div>
              </div>
            </div>

            <div className="space-y-6 pt-8" data-aos="fade-left" data-aos-delay="200">
               <h1 className="text-5xl md:text-6xl font-bold text-pink-400 mb-4" data-aos="fade-down">{t('about.title')}</h1>
              <h2 className="text-4xl font-bold text-gray-600">{t('about.name')}</h2>
              <div className="space-y-4 text-gray-600 text-lg leading-relaxed">
                <p><strong>{t('about.bio1')}</strong></p>
                <p>{t('about.bio2')}</p>
                <p>{t('about.bio3')}</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="glass-card p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="100">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <BookOpen className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('about.myApproach')}</h3>
              <p className="text-gray-600">{t('about.approachDesc')}</p>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="200">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <Award className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('about.professionalEthics')}</h3>
              <p className="text-gray-600">{t('about.ethicsDesc')}</p>
            </div>

            <div className="glass-card p-8 rounded-xl shadow-lg" data-aos="fade-up" data-aos-delay="300">
              <div className="bg-primary-300 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                <Heart className="w-8 h-8 text-gray-600" />
              </div>
              <h3 className="text-2xl font-bold text-pink-400 mb-4">{t('about.arcanosHabana')}</h3>
              <p className="text-gray-600">{t('about.arcanosDesc')}</p>
            </div>
          </div>

          <div className="glass-card text-gray-600 p-8 md:p-12 rounded-2xl shadow-xl" data-aos="zoom-in-up">
            <h3 className="text-3xl font-bold mb-6 text-pink-400">{t('about.ethicalCode')}</h3>
            <p className="text-lg text-gray-600 mb-6">{t('about.ethicalCodeDesc')}</p>
            <a
              href="https://eticaytarot.com/continente-americano/arlene-tarot/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center space-x-2 bg-gradient-to-r from-primary-300 to-pink-400 hover:from-primary-400 hover:to-pink-500 text-gray-600 px-8 py-4 rounded-full font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105"
            >
              <span>{t('about.viewEthicalCode')}</span>
              <ExternalLink className="w-5 h-5" />
            </a>
          </div>

          <div className="mt-16 p-8 rounded-2xl shadow-xl">
            <h3 className="text-3xl font-bold text-pink-400 mb-8 text-center" data-aos="fade-up">{t('about.gallery')}</h3>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="aspect-square bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center" data-aos="flip-left" data-aos-delay="100">
                <img src="./1.jpeg" alt="Tarot 1" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center" data-aos="flip-up" data-aos-delay="200">
                <img src="./2.jpeg" alt="Tarot 2" className="w-full h-full object-cover" />
              </div>
              <div className="aspect-square bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center" data-aos="flip-right" data-aos-delay="300">
                <img src="./3.jpeg" alt="Tarot 3" className="w-full h-full object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
